import type { AdminClientContext, AdminHttpClient } from './client.js';

type MethodKeys =
  | 'listExtensionReleases'
  | 'promoteExtensionRelease'
  | 'rollbackExtensionRelease'
  | 'withdrawExtensionRelease';

export function buildDeviceMethods(ctx: AdminClientContext) {
  const { transport, token, idemKey } = ctx;
  return {
    listExtensionReleases: (extensionId = 'hwp', platform = 'win32') =>
      transport.listExtensionReleases(token(), extensionId, platform),
    promoteExtensionRelease: (extensionId, version, platform = 'win32', idempotencyKey) =>
      transport.promoteExtensionRelease(token(), {
        extensionId, platform, version,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    rollbackExtensionRelease: (extensionId, version, platform = 'win32', idempotencyKey) =>
      transport.rollbackExtensionRelease(token(), {
        extensionId, platform, version,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    withdrawExtensionRelease: (extensionId, platform = 'win32', idempotencyKey) =>
      transport.withdrawExtensionRelease(token(), {
        extensionId, platform,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
